<template>
  <br>
  <div>
    <button class="light-button" @click="clickHandler">Trainers</button>
    <div v-if="itemList.length > 0" class="trainer-cards">
      <v-tooltip v-for="item in itemList" :key="item.id" location="top">
        <template #activator="{ props: tooltipProps }">
          <div class="trainer-card" v-bind="tooltipProps" @click="handleItemClicked(item)">
            <div class="trainer-card__name">{{ item.name }}</div>
            <div class="trainer-card__description">{{ item.description }}</div>
          </div>
        </template>
        <div><strong>{{ item.id }}</strong></div>
        <div>{{ item.description }}</div>
      </v-tooltip>
    </div>
    <div v-else class="no-items">No experiments</div>
  </div>
</template>

<script setup>

import { onMounted, ref, inject } from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

import { useRouter } from 'vue-router';
import { encodeIdToUid } from '@/assets/js/utils.js';

const emit = defineEmits(['card_updated']);
const props = defineProps({ projectID: Number });
const isPublic = inject('isPublic', false);
const itemList = ref([]);
const router = useRouter();

function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
}

function clickHandler() {
  router.push({ name: `${isPublic ? 'public.' : ''}experiments`, params: { projectId: encodeIdToUid(props.projectID, 'p') } });
}

onMounted(async () => {
  getDatasets();
});

async function getDatasets() {
  const dataConnect = new DatastoreConnect();
  const result = await dataConnect.getExperimentList({ project_id: props.projectID })
    .then(async (data) => {
      if (!data.result) {

      } else {
        const exp = data.result;
        itemList.value = [];

        for (let k = 0; k < exp.length; k++) {
          const item = {};
          item.url = `/experiment/${props.projectID}`;
          item.id = `exp-${exp[k].id.toString(16)}`;
          item.exp_id = exp[k].id;
          item.name = exp[k].name;
          item.createdAt = formatDate(exp[k].date);
          item.description = exp[k].description;
          itemList.value.push(item);
        }
      }
    })
    .catch((error) => {

    });
}

function handleItemClicked(item) {
  router.push({
    name: 'trainings.list',
    params: {
      expId: encodeIdToUid(item.exp_id, 'exp'),
    },
  });
}

</script>

<style lang="scss" scoped>
.trainer-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.trainer-card {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease;
  min-width: 240px;
  max-width: 300px;

  &:hover {
    border-color: #0066cc;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.1);
  }

  &__name {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
    color: #0066cc;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__description {
    font-size: 12px;
    color: #666666;
    line-height: 1.4;
    min-height: calc(1.4em * 3);
    display: -webkit-box;
    line-clamp: 3;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.no-items {
  margin-top: 10px;
  color: #999;
  font-size: 0.9rem;
}
</style>
